import { useEffect, useState } from "react";
import shortid from "shortid";
import { useTranslation } from "react-i18next";
import { FORMULARIO_CHECKLIST } from "../page/checklist/const-select-formulario-checklist";
import { ID_CHECKLIST } from "../utils/const/id-checklist-const";
import { FORMULARIO_VIAJE } from "../utils/const/formulario-viaje-const";

const ComponentDetalleChecklist = ({
    detalleChecklist,
    infoFormulario,
    showFooter = true,
    formularioPieDePagina,
    infoViaje = null,
    respuestaChecklist = null,
}) => {

    const { t } = useTranslation();

    const [listaViaje, setListaViaje] = useState(null);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            // console.log('infoViaje', infoViaje);
            // console.log('respuestaChecklist', respuestaChecklist);
            if (respuestaChecklist !== null) {
                let listaViaje = respuestaChecklist.listaViaje;
                listaViaje = JSON.parse(listaViaje);
                setListaViaje(listaViaje);
            }
        } catch (err) {
            console.error('Error en iniciar', err);
        }
    };

    const renderTurnoRuta = (info) => {
        try {
            // console.log('renderTurnoRuta info');
            // console.log(info);
            const { idChecklist, value } = info;
            let turnoDescripcion = null;
            let rutaDescripcion = null;
            return value.map((item) => {
                turnoDescripcion = item?.descripcion || '';
                rutaDescripcion = item?.ruta?.descripcion || '';
                return (
                    <p style={{ color: '#212529' }}>{turnoDescripcion}: {rutaDescripcion}</p>
                );
            });

        } catch (err) {
            console.error('Error en renderTurnoRuta', err);
            return null;
        }
    };

    const renderInfoFormulario = (info) => {
        try {
            // console.log('renderInfoFormulario info');
            // console.log(info);
            const { label, isJson, value, idConcepto, idChecklist } = info;
            // console.log('value', value);
            // console.log('idChecklist', idChecklist);
            // console.log('info s');
            // console.log(
            //     isJson === true &&
            //     (
            //         idChecklist !== ID_CHECKLIST.CSM_BOLTRACK ||
            //         idChecklist !== ID_CHECKLIST.CSM_ISA
            //     ) &&
            //     Array.isArray(value) &&
            //     idConcepto === FORMULARIO_CHECKLIST.TURNO
            // );
            return (
                <div>
                    <p style={{ color: '#212529', fontWeight: 'bold' }}>{label}</p>
                    {isJson === false || isJson === undefined && <p style={{ color: '#212529' }}>{value}</p>}
                    {isJson === true &&
                        Array.isArray(value) &&
                        idConcepto === FORMULARIO_CHECKLIST.PERSONAL_TRANSPORTAR &&
                        value.map((item) => (
                            <p style={{ color: '#212529' }}>{item.descripcion}</p>
                        ))}
                    {isJson === true &&
                        Array.isArray(value) &&
                        idConcepto === FORMULARIO_CHECKLIST.RUTA &&
                        value.map((item) => (
                            <p style={{ color: '#212529' }}>{item.descripcion}</p>
                        ))
                    }
                    {isJson === true &&
                        (
                            idChecklist === ID_CHECKLIST.CSM_BOLTRACK ||
                            idChecklist === ID_CHECKLIST.CSM_ISA
                        ) &&
                        Array.isArray(value) &&
                        idConcepto === FORMULARIO_CHECKLIST.TURNO &&
                        renderTurnoRuta(info)

                    }
                    {isJson === true &&
                        idChecklist !== ID_CHECKLIST.CSM_BOLTRACK &&
                        idChecklist !== ID_CHECKLIST.CSM_ISA &&
                        Array.isArray(value) &&
                        idConcepto === FORMULARIO_CHECKLIST.TURNO &&
                        value.map((item) => (
                            <p style={{ color: '#212529' }}>{item.descripcion}</p>
                        ))
                    }
                </div>
            );
        } catch (err) {
            console.error('Error en renderInfoFormulario', err);
            return null;
        }
    };

    const renderChildViaje = (item) => {
        try {
            // console.log('renderChildViaje');
            // console.log('item', item);
            const { idConcepto, concepto, value } = item;
            switch (idConcepto) {
                case FORMULARIO_VIAJE.SELECCIONAR_RUTA:
                    return (
                        <div
                            key={shortid.generate()}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderBottom: '1px solid #ccc',
                                padding: '10px 0',
                                backgroundColor: '#f8f9fa',
                                width: '50%',
                            }}
                        >
                            <p style={{ color: '#212529', fontWeight: 'bold' }}>{concepto}</p>
                            <p style={{ color: '#212529' }}>{value?.value}</p>
                        </div>
                    );
                case FORMULARIO_VIAJE.INPUT_HORA_DE_PASO:
                    return (
                        <div
                            key={shortid.generate()}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderBottom: '1px solid #ccc',
                                padding: '10px 0',
                                backgroundColor: '#f8f9fa',
                                width: '50%',
                            }}>
                            <p style={{ color: '#212529', fontWeight: 'bold' }}>{concepto}</p>
                            <p style={{ color: '#212529' }}>{value}</p>
                        </div>
                    );
                case FORMULARIO_VIAJE.INPUT_KILOMETRO:
                    return (
                        <div
                            key={shortid.generate()}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderBottom: '1px solid #ccc',
                                padding: '10px 0',
                                backgroundColor: '#f8f9fa',
                                width: '50%',
                            }}>
                            <p style={{ color: '#212529', fontWeight: 'bold' }}>{concepto}</p>
                            <p style={{ color: '#212529' }}>{value}</p>
                        </div>
                    );
                case FORMULARIO_VIAJE.INPUT_TIEMPO_DESCANSO:
                    return (
                        <div
                            key={shortid.generate()}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderBottom: '1px solid #ccc',
                                padding: '10px 0',
                                backgroundColor: '#f8f9fa',
                                width: '50%',
                            }}>
                            <p style={{ color: '#212529', fontWeight: 'bold' }}>{concepto}</p>
                            <p style={{ color: '#212529' }}>{value}</p>
                        </div>
                    );
                case FORMULARIO_VIAJE.SELECCIONAR_REPORTAR_UBICACION:
                    return (
                        <div
                            key={shortid.generate()}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderBottom: '1px solid #ccc',
                                padding: '10px 0',
                                backgroundColor: '#f8f9fa',
                                width: '50%',
                            }}>
                            <p style={{ color: '#212529', fontWeight: 'bold' }}>{concepto}</p>
                            <p style={{ color: '#212529' }}>{value?.value}</p>
                        </div>
                    );
                case FORMULARIO_VIAJE.INPUT_OBSERVACION:
                    return (
                        <div
                            key={shortid.generate()}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderBottom: '1px solid #ccc',
                                padding: '10px 0',
                                backgroundColor: '#f8f9fa',
                                width: '50%',
                            }}>
                            <p style={{ color: '#212529', fontWeight: 'bold' }}>{concepto}</p>
                            <p style={{ color: '#212529' }}>{value}</p>
                        </div>
                    );
                default:
                    return null;
            }
            return null;
        } catch (err) {
            console.error('Error en renderChildViaje', err);
            return null;
        }
    };

    const render = () => {
        try {
            return (
                <div style={{ paddingLeft: '10px', paddingRight: '10px' }} key={shortid.generate()}>
                    <div
                        key={shortid.generate()}
                        style={{
                            marginBottom: '20px',
                            padding: '10px',
                            backgroundColor: '#6c757d',
                            color: 'white',
                            borderRadius: '5px',
                        }}
                    >
                        <label style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
                            {t('label_formulario')}
                        </label>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                flexDirection: 'row',
                            }}
                        >
                            {Array.isArray(infoFormulario) && infoFormulario.length > 0 && infoFormulario.map((info) => (
                                <div
                                    key={shortid.generate()}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        borderBottom: '1px solid #ccc',
                                        padding: '10px 0',
                                        backgroundColor: '#f8f9fa',
                                        width: '50%',
                                    }}
                                >
                                    {renderInfoFormulario(info)}
                                </div>
                            ))}
                        </div>
                    </div>

                    {respuestaChecklist !== null &&
                        <div
                            key={shortid.generate()}
                            style={{
                                marginBottom: '20px',
                                padding: '10px',
                                backgroundColor: '#6c757d',
                                color: 'white',
                                borderRadius: '5px',
                            }}
                        >
                            <label style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
                                {t('label_viaje')}
                            </label>
                            <div>
                                {Array.isArray(listaViaje) && listaViaje.length > 0 && listaViaje.map((viaje) => {
                                    // console.log('viaje', viaje);
                                    return (
                                        <div
                                            key={shortid.generate()}
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                flexDirection: 'row',
                                            }}
                                        >
                                            {Array.isArray(viaje) && viaje.length > 0 && viaje.map((item) => (
                                                renderChildViaje(item)
                                            ))}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    }

                    {Array.isArray(detalleChecklist) === true && detalleChecklist.map((seccion) => (
                        <div
                            key={shortid.generate()}
                            style={{
                                marginBottom: '20px',
                                padding: '10px',
                                backgroundColor: '#6c757d',
                                color: 'white',
                                borderRadius: '5px',
                            }}
                        >
                            <label style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
                                {seccion.nombreSeccion}
                            </label>
                            <div
                                style={{
                                    display: 'flex',
                                    borderBottom: '1px solid #ccc',
                                    padding: '10px 0',
                                }}
                            >
                                <div style={{ flex: 8 }}>
                                    <label style={{ fontWeight: 'bold' }}>{t('label_pregunta')}</label>
                                </div>
                                <div style={{ flex: 4 }}>
                                    <label style={{ fontWeight: 'bold' }}>{t('label_respuesta')}</label>
                                </div>
                            </div>
                            {seccion.preguntas.map((pregunta) => (
                                <div key={shortid.generate()}>
                                    <div
                                        key={shortid.generate()}
                                        style={{
                                            display: 'flex',
                                            borderBottom: '1px solid #ccc',
                                            padding: '10px 0',
                                            backgroundColor: '#f8f9fa',
                                        }}
                                    >
                                        <div style={{ flex: 8 }}>
                                            <label style={{ color: '#212529' }}>{pregunta.labelPregunta}</label>
                                        </div>
                                        <div style={{ flex: 4 }}>
                                            <p style={{ color: '#212529' }}>{pregunta.labelOpcionRespuesta}</p>
                                            <p style={{ color: '#212529' }}>{pregunta.respuesta}</p>
                                            {pregunta.urlArchivo &&
                                                <div className="flex justify-end"
                                                    style={{
                                                        backgroundColor: '#f8f9fa',
                                                    }}
                                                >
                                                    <div className="flex flex-col justify-end p-2.5 bg-gray-100">
                                                        <img
                                                            className="w-[200px] h-[200px] object-contain"
                                                            src={pregunta.urlArchivo}
                                                            alt="Preview"
                                                            crossOrigin="anonymous"
                                                        />
                                                        <a
                                                            href={pregunta.urlArchivo}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-[#212529] no-underline break-all text-sm max-w-[200px]"
                                                        >
                                                            {t('label_ver_imagen')}
                                                        </a>
                                                    </div>
                                                </div>
                                            }
                                            {pregunta.urlFotoRespuesta !== null && String(pregunta.urlFotoRespuesta).trim().length !== 0 &&
                                                <div className="flex justify-end"
                                                    style={{
                                                        backgroundColor: '#f8f9fa',
                                                    }}
                                                >
                                                    <div className="flex flex-col p-2.5 bg-gray-100">
                                                        <img
                                                            className="w-[200px] h-[200px] object-contain"
                                                            src={pregunta.urlFotoRespuesta}
                                                            alt="Preview"
                                                            crossOrigin="anonymous"
                                                        />
                                                        <a
                                                            href={pregunta.urlFotoRespuesta}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-[#212529] no-underline break-all text-sm max-w-[200px] pt-2.5 text-center"
                                                        >
                                                            {t('label_ver_foto_respuesta')}
                                                        </a>
                                                    </div>
                                                </div>
                                            }
                                            {pregunta.detalleNotaObservacionRespuesta !== null && String(pregunta.detalleNotaObservacionRespuesta).trim().length !== 0 &&
                                                <p
                                                    className="flex justify-end italic-text p-2.5"
                                                    style={{ color: '#212529', fontStyle: "italic" }}
                                                >{pregunta.detalleNotaObservacionRespuesta}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                    {showFooter === true && formularioPieDePagina !== null &&
                        <>
                            <div
                                key={shortid.generate()}
                                style={{
                                    marginBottom: '20px',
                                    padding: '10px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    borderRadius: '5px',
                                }}
                            >
                                <label style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
                                    {t('label_pie_de_pagina')}
                                </label>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        flexDirection: 'row',
                                    }}
                                >
                                    {Array.isArray(formularioPieDePagina) && formularioPieDePagina.length > 0 && formularioPieDePagina.map((info) => (
                                        <div
                                            key={shortid.generate()}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                borderBottom: '1px solid #ccc',
                                                padding: '10px 0',
                                                backgroundColor: '#f8f9fa',
                                                width: '100%',
                                            }}
                                        >
                                            <div>
                                                <p style={{ color: '#212529', fontWeight: 'bold' }}>{info.texto}</p>
                                                <p style={{ color: '#212529' }}>{info.respuesta}</p>
                                                {info.esImagen === 1 && (
                                                    <div className="flex justify-end"
                                                        style={{
                                                            backgroundColor: '#f8f9fa',
                                                        }}
                                                    >
                                                        <div className="flex flex-col justify-end p-2.5 bg-gray-100">
                                                            <img
                                                                className="w-[200px] h-[200px] object-contain"
                                                                src={info.urlImagen}
                                                                alt="Preview"
                                                                crossOrigin="anonymous"
                                                            />
                                                            <a
                                                                href={info.urlImagen}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-[#212529] no-underline break-all text-sm max-w-[200px]"
                                                            >
                                                                {info.urlImagen}
                                                            </a>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    }
                </div>
            );
        } catch (err) {
            console.error('Error en render', err);
            return (<div>{JSON.stringify(err)}</div>)
        }
    };

    return render();
}

export default ComponentDetalleChecklist;